import { ca } from '@cian/analytics';

export function trackMyHomeTrapShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'myhome',
    action: 'show_sopr',
    label: 'add_address',
    page: {
      pageType: 'BuildingProgressJK',
      siteType: 'desktop',
      extra: {
        trap_type: 'MyHomeNewBuildingHistoryAlbum',
      },
    },
    useLastProducts: true,
  });
}

export function trackMyHomeTrapClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'myhome',
    action: 'click',
    label: 'add_address',
    page: {
      pageType: 'BuildingProgressJK',
      siteType: 'desktop',
      extra: {
        trap_type: 'MyHomeNewBuildingHistoryAlbum',
      },
    },
    useLastProducts: true,
  });
}
